import { Box, BoxProps } from "@chakra-ui/react";

export default function Well(props: BoxProps) {
  return (
    <Box
      p={4}
      bg="cardBackground"
      boxShadow="0 1px 3px rgba(0,0,0,.05) inset"
      {...props}
    />
  );
}
